import {CardColor} from "./api/CardColor";
import {CardName} from "./api/CardName";
import {CustomSpineAnimation} from "./CustomSpineAnimation";

export class CardAnimation extends CustomSpineAnimation {

    private static readonly ANIMATION_CONFIG = {
        NAME: "cardTurn",
        STATES: {
            IDLE_CARD: "idle_card",
            IDLE_COVERED: "idle_covered",
            COVER: "cover",
            UNCOVER: "uncover",
            CHECK_BLACKJACK: "checkBlackjack",
        },
        SLOT_CONTAINERS: {
            CARD_FRONT: "plain",
        },
    };

    private static readonly CARD_FRONT_ANIMATION_NAME = "cardFront";

    private readonly SCALE = 0.2;

    private cardFront: CustomSpineAnimation;

    constructor() {
        super(CardAnimation.ANIMATION_CONFIG.NAME);
        this.scale.x = this.SCALE;
        this.scale.y = this.SCALE;
        this.createAndAddCardFrontAnimation();
        this.showCoveredCard();
    }

    public async uncoverCard(): Promise<void> {
        await this.playThanResolveOnAnimationCompleteAndRemoveAllListeners(
            CardAnimation.ANIMATION_CONFIG.STATES.UNCOVER);
    }

    public async coverCard(): Promise<void> {
        await this.playThanResolveOnAnimationCompleteAndRemoveAllListeners(CardAnimation.ANIMATION_CONFIG.STATES.COVER);
    }

    public showUncoveredCard(): void {
        this.play(CardAnimation.ANIMATION_CONFIG.STATES.IDLE_CARD);
    }

    public showCoveredCard(): void {
        this.play(CardAnimation.ANIMATION_CONFIG.STATES.IDLE_COVERED);
    }

    public async checkBlackjack(): Promise<void> {
        await this.playThanResolveOnAnimationCompleteAndRemoveAllListeners(
            CardAnimation.ANIMATION_CONFIG.STATES.CHECK_BLACKJACK);
    }

    public setCardFront(cardColor: CardColor, cardName: CardName): void {
        this.cardFront.play(cardColor + "_" + cardName);
    }

    private createAndAddCardFrontAnimation(): void {
        this.cardFront = new CustomSpineAnimation(CardAnimation.CARD_FRONT_ANIMATION_NAME);
        this.setCardFront(CardColor.SPADE, CardName.ACE);
        const slot = this.getSlotContainer(CardAnimation.ANIMATION_CONFIG.SLOT_CONTAINERS.CARD_FRONT, true);
        slot.addChild(this.cardFront);
        this.cardFront.scale.x = -1;
    }
}



// WEBPACK FOOTER //
// ./src/app/CardAnimation.ts